import moment from "moment";
import { connect } from "react-redux";
import { Form, Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";

import SearchInventory from "../SearchInventory/SearchInventory";
import ConsolidationModal from "../ConfirmationModal/ConsolidationModal";
import {
  Button,
  CheckboxField,
  ProductTagList,
  ProductModalHeader,
  CustomInventoryComponent,
  AddInventoryProductPrices,
  AddEditInventoryModalPricesHistoryStats,
} from "../../../../shared/components";
import { SidebarToggleIcon } from "../../../../assets/icons/iconsProvider";
import {
  systemActions,
  shopifyActions,
  inventoryActions,
} from "../../../../redux/actions";
import {
  PRODUCT_TYPES_ENUMS,
  PRODUCT_CONDITIONS_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../../../../system/globalEnums";
import {
  customToast,
  isSystemProduct,
  onSelectTagsChange,
  updatePreserveState,
  isSerialNumberUnique,
  getProductSubCategory,
  handleConditionChange,
  updateProductImageUrl,
  getMarginDropdownValue,
  getCustomProductIfExist,
  getTypeOrCategoryObject,
  handleBeautifyMarketPrice,
  getTypeOrCategoryIdByName,
  getCustomItemInitialValues,
  findInventoryProductDetail,
  handleProductConditionUpdate,
  handleAddInventorySubmitBeautify,
  getAddInventoryPricePayloadObject,
  getAddInventoryPartialInitialValues,
  getAddInventoryRootPayloadPartialObject,
  isAddInventoryInProgress,
  isSpinnerEnabled,
} from "../../../../shared/utility";
import {
  toastType,
  preserveMode,
  EMPTY_STRING,
  toastMessages,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  INITIAL_VALUE_TYPES,
  toggleSwitchButtonConstants,
  INVENTORY_PRODUCT_DEFAULT_DATA_OBJECT,
  shopifyConstants,
} from "../../../../constants";
import {
  addCustomItemValidationSchema,
  addNewIventoryValidationSchema,
} from "../../../../shared/validationSchema/validationSchema";

const AddInventoryItem = (props) => {
  //-------Destructure props
  const {
    shopify,
    inventory,
    productTags,
    customTypes,
    currentStore,
    addInventory,
    spinnerArray,
    tradeDiscount,
    addCustomItem,
    toggleAddModal,
    activateSpinner,
    customCategories,
    handleClearFilter,
    deactivateSpinner,
    inventoryProducts,
    customSubCategories,
    addInventoryItemModal,
    getShopifyMappingsById,
    priceChartingProductInfo,
    setProductShopifySettings,
    toggleAddInventoryItemModal,
    setPriceChartingProductInfo,
    getInventoryByPricechartingId,
    emptyPriceChartingProductObject,
  } = props;

  //-------reducers
  const { shopifySettings } = shopify;
  const { productShopifySettings } = inventory;
  const { markupPresets, tradeinMargin } = tradeDiscount;

  //------useRef
  const formikRef = useRef();
  const asyncSelectRef = useRef();
  const hiddenFileInput = useRef(null);

  const preserveStateRef = useRef({
    mode: preserveMode.PARTIAL,
    hasInteracted: false,
  });

  //-------useState
  const [productUrl, setProductUrl] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [conditionList, setConditionList] = useState([]);
  const [productCondition, setProductCondition] = useState();
  const [productTagsList, setProductTagsList] = useState([]);
  const [isProductExist, setIsProductExist] = useState(false);
  const [marginTypeObject, setMarginTypeObject] = useState({});
  const [isCustomItemTab, setIsCustomItemTab] = useState(false);
  const [productType, setProductType] = useState(PRODUCT_TYPES_ENUMS.ALL);
  const [customProductSelectedTags, setCustomProductSelectedTags] = useState(
    []
  );
  const [productDataObject, setProductDataObject] = useState(
    INVENTORY_PRODUCT_DEFAULT_DATA_OBJECT
  );
  const [inStockPriceValue, setInStockPriceValue] = useState(0);

  //-------inital values for custom item
  const customItemInitialValues = {
    ...getCustomItemInitialValues(),
  };
  //-------initial values for add inventory item
  const initialValues = {
    box:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE &&
      selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.WITH_BOX)
        ? true
        : false,
    manual:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE
        ? selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL)
          ? false
          : true
        : productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE
        ? selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.WITH_MANUAL)
          ? true
          : false
        : false,
    cables:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE
        ? selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.MISSING_WIRES)
          ? false
          : true
        : false,
    controller:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE
        ? selectedTags?.includes(
            inventoryConstants.PRODUCT_TAGS.MISSING_CONTROLLER
          )
          ? false
          : true
        : false,
    costOfGoods: productDataObject.costOfGoods || EMPTY_STRING,
    inStockPrice: inStockPriceValue,
    ...getAddInventoryPartialInitialValues(
      productDataObject,
      INITIAL_VALUE_TYPES.ADD_INVENTORY,
      formikRef,
      preserveStateRef.current
    ),
  };
  //-------onselectedtagchange
  const onCustomProductSelectTagsChange = (selectedTags) => {
    const selectedTagList = selectedTags.map((tag) => tag.label);
    setCustomProductSelectedTags(selectedTagList);
  };

  //-------handle inventory submit
  const handleAddInvetorySubmit = async (values) => {
    // ALL preserve: Form submit may trigger reinitialize; force preserve to prevent value loss
    preserveStateRef.current.hasInteracted = true;
    preserveStateRef.current.mode = preserveMode.ALL;

    if (!productDataObject?.productName) {
      customToast(toastMessages.PLEASE_SELECT_SOME_PRODUCT, toastType.ERROR);
    } else if (
      isSystemProduct(getProductSubCategory(productDataObject?.genre)) &&
      !isSerialNumberUnique(values.serialNumber, inventoryProducts || [])
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
      return;
    }
    if (values?.serialNumber) {
      const quantityToCheck =
        values.isSeparateQuantity === false
          ? values.quantity
          : values.onlineQuantity;
      if (quantityToCheck > 1) {
        customToast(toastMessages.SYSTEM_QUANTITY_MUST_BE_1, toastType.ERROR);
        return;
      }
    }

    addInventory(
      handleAddInventorySubmitBeautify({
        ...getAddInventoryRootPayloadPartialObject({
          ...productDataObject,
          productType: productType,
          ...values,
          shopifySettingId: productShopifySettings?.marginType?.isDefault
            ? productDataObject.shopifySettingId
            : productShopifySettings?.marginObject?.id || EMPTY_STRING,
        }),
        product_id: productDataObject.productId,
        product_name: productDataObject.productName,
        category_name: productDataObject.consoleName,
        description: "",
        sku: [inventoryConstants.AUTO_GENERATED],
        store: {
          id: currentStore?.id,
          name: currentStore?.storeName,
        },
        date_added: new Date(),
        price: getAddInventoryPricePayloadObject({
          ...values,
          type: productCondition?.value,
          marketPrice: handleBeautifyMarketPrice(productDataObject),
        }),
        additionalCheckList: [],
        tags: selectedTags?.map((tag) => tag),
        apiSource:
          priceChartingProductInfo?.productMetaData?.sourceApi ||
          productDataObject?.sourceApi ||
          EMPTY_STRING,
        imgUrl: productDataObject?.imgUrl || EMPTY_STRING,
        epid: productDataObject.epid || EMPTY_STRING,
        tcgPlayerUrl: productDataObject.tcgPlayerUrl || EMPTY_STRING,
        trackQuantity: true,
      }),
      handleHideModal
    );
  };

  //-------hide modal
  const handleHideModal = () => {
    handleClearFilter();
    toggleAddInventoryItemModal();
    toggleAddModal(false);
    clearAddInventoryForm();
    setIsCustomItemTab(false);
  };

  //-------empty product data object
  const emptyProductDataObject = () => {
    setProductDataObject(INVENTORY_PRODUCT_DEFAULT_DATA_OBJECT);
  };

  //-------clear form
  const clearAddInventoryForm = () => {
    setSelectedTags([]);
    setProductType(PRODUCT_TYPES_ENUMS.ALL);
    setConditionList([]);
    setProductTagsList([]);
    emptyProductDataObject();
    emptyPriceChartingProductObject();
    setProductUrl(EMPTY_STRING);
    setProductCondition(EMPTY_STRING);
    preserveStateRef.current.mode = preserveMode.PARTIAL;
    preserveStateRef.current.hasInteracted = false;
  };

  //-------handle replace logo click
  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };

  //------- handle custom item submit
  const handleCustomItemSubmit = async (values) => {
    const sendToData = {
      upc: values.upc ?? EMPTY_STRING,
      barcode: values.barcode ?? EMPTY_STRING,
      tags: [
        ...(customProductSelectedTags || []),
        inventoryConstants.CUSTOM_ITEM_TAG,
      ],
      cardRarity: "",
      cardNumber: "",
      description: values.description,
      tcgPlayerUrl: "",
      serialNumber: "",
      additionalCheckList: [],
      product_name: values.product_name,
      sku: [inventoryConstants.AUTO_GENERATED],
      apiSource: inventoryConstants.CUSTOM_ITEM,
      product_id: inventoryConstants.CUSTOM_ITEM,
      date_added: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      category_name: getTypeOrCategoryObject(
        customCategories,
        values.category_name
      )?.name,
      subcategory:
        getTypeOrCategoryObject(customSubCategories, values.subcategory)
          ?.name || "",
      store: {
        id: currentStore.id,
        name: currentStore.storeName,
      },
      price: getAddInventoryPricePayloadObject({
        costOfGoods: values.costOfGoods,
        onlineUnitPurchasePrice: values.costOfGoods,
        inStockPrice: values.inStockPrice,
        quantity: values.trackQuantity ? values.quantity : 0,
        type: values.condition,
        onlineQuantity: values.trackQuantity ? values.onlineQuantity : 0,
        onlineUnitSellPrice: values.onlineUnitSellPrice,
        isOnlineUnitSellPrice: values.isOnlineUnitSellPrice || false,
        isOnlineQuantity: values.isOnlineQuantity || false,
        isLinkToShopify: values.isLinkToShopify || false,
        isSeparateQuantity: values.isSeparateQuantity || false,
      }),
      productType: getTypeOrCategoryObject(customTypes, values.productType)
        ?.productType,
      trackQuantity: values.trackQuantity,
      isLinkToShopify: values.isLinkToShopify || false,
      shopifyId: `${values?.shopifyId || EMPTY_STRING}`,
      variantId: `${values?.variantId || EMPTY_STRING}`,
      shopifySettingId: `${values?.shopifySettingId}` || EMPTY_STRING,
      imgUrl: values?.imgUrl || EMPTY_STRING,
      shopifyInventoryItemId: `${values?.shopifySettingId}` || EMPTY_STRING,
    };
    addCustomItem(
      [sendToData],
      toastMessages.PORDUCT_ADDED_SUCCESSFULLY,
      handleHideModal
    );

    return;
  };
  useEffect(() => {
    setInStockPriceValue(
      productDataObject?.inStorePrice || productDataObject?.inStockPrice || 0
    );
  }, [productDataObject]);

  //-------update product condition and type
  useEffect(() => {
    if (
      priceChartingProductInfo?.productMetaData?.sourceApi ===
      inventoryConstants.CUSTOM_ITEM
    ) {
      const productObject = priceChartingProductInfo.productObject;
      setCustomProductSelectedTags(
        productObject?.tags?.filter(
          (tag) => tag !== inventoryConstants.CUSTOM_ITEM_TAG
        )
      );

      let fieldValues = {
        productType: getTypeOrCategoryIdByName(
          customTypes,
          productObject.productType
        ),
        upc: productObject.upc,
        product_name: productObject.product_name,
        category_name: getTypeOrCategoryIdByName(
          customCategories,
          productObject.category_name,
          productObject.productType
        ),
        condition: productObject?.price?.type,
        costOfGoods: productObject?.price?.unit_purchase_price,
        description: productObject?.description,
        subcategory: getTypeOrCategoryIdByName(
          customSubCategories,
          productObject.subcategory,
          productObject.productType,
          productObject.category_name
        ),
        trackQuantity:
          productObject?.trackQuantity === undefined
            ? true
            : productObject?.trackQuantity,
        isLinkToShopify: productObject.isLinkToShopify,
        isOnlineUnitSellPrice: productObject?.price?.isOnlineUnitSellPrice,
        isOnlineQuantity: productObject?.price?.isOnlineQuantity,
        onlineQuantity: 1,
        onlineUnitSellPrice: productObject?.price?.onlineUnitSellPrice || 0,
        shopifyId: productObject?.shopifyId || EMPTY_STRING,
        shopifySettingId: productObject?.shopifySettingId || EMPTY_STRING,
        variantId: productObject?.variantId || EMPTY_STRING,
        quantity: 1,
        stockPrice: productObject?.price?.unit_sell_price,
        inStockPrice: productObject?.price?.unit_sell_price,
        imgUrl: productObject?.imgUrl || EMPTY_STRING,
      };

      Object.entries(fieldValues).forEach(([field, value]) => {
        formikRef.current?.setFieldValue(field, value);
      });
      setIsCustomItemTab(true);
    } else {
      if (addInventoryItemModal) {
        handleProductConditionUpdate(
          currentStore,
          priceChartingProductInfo,
          getInventoryByPricechartingId,
          setProductType,
          setProductUrl,
          productDataObject,
          setProductDataObject,
          productTags,
          setProductTagsList,
          () => {},
          () => {},
          setConditionList,
          setProductCondition
        );
      }
    }
    // eslint-disable-next-line
  }, [addInventoryItemModal, priceChartingProductInfo]);

  //-------Handle Shopfiy In-Store & Online Quantity Check Change
  const handleStoreAndOnlineQuantityChange = (value) => {
    setProductDataObject((prevState) => ({
      ...prevState,
      isOnlineQuantity: value,
    }));
  };

  const handleCustomShopifyStatusChange = (option) => {
    // ALL preserve: Shopify operations may trigger reinitialize; keep all form state
    updatePreserveState(preserveStateRef, preserveMode.ALL, true);
  };

  useEffect(() => {
    if (
      productCondition?.value &&
      priceChartingProductInfo?.productMetaData?.sourceApi ===
        inventoryConstants.PRICECHARTING_API
    ) {
      findInventoryProductDetail(
        currentStore,
        productCondition.value,
        productType,
        markupPresets,
        tradeinMargin,
        selectedTags,
        productDataObject.cardRarity,
        productDataObject,
        inventoryProducts,
        setProductDataObject,
        priceChartingProductInfo,
        () => {},
        undefined,
        {
          shopifySettings,
          getShopifyMappingsById,
          productShopifySettings,
          setProductShopifySettings,
        }
      );
    } else if (
      priceChartingProductInfo?.productMetaData?.sourceApi ===
        inventoryConstants.TCG_PLAYER_API &&
      priceChartingProductInfo?.productMetaData?.condition?.value
    ) {
      findInventoryProductDetail(
        currentStore,
        priceChartingProductInfo?.productMetaData?.condition?.value,
        productType,
        markupPresets,
        tradeinMargin,
        selectedTags,
        productDataObject.cardRarity,
        productDataObject,
        inventoryProducts,
        setProductDataObject,
        priceChartingProductInfo,
        () => {},
        undefined,
        {
          shopifySettings,
          getShopifyMappingsById,
          productShopifySettings,
          setProductShopifySettings,
        }
      );
    }
    updateProductImageUrl({
      productType,
      productCondition,
      selectedTags,
      inventoryProducts,
      priceChartingProductInfo,
      setProductDataObject,
      cardRarity: productDataObject.cardRarity,
    });
    // eslint-disable-next-line
  }, [inventoryProducts]);

  useEffect(() => {
    let isCurrent = true;
    if (productCondition?.value) {
      findInventoryProductDetail(
        currentStore,
        productCondition?.value,
        productType,
        markupPresets,
        tradeinMargin,
        selectedTags,
        productDataObject.cardRarity,
        productDataObject,
        inventoryProducts,
        (updatedProductData) => {
          if (isCurrent) {
            setProductDataObject(updatedProductData);
          }
        },
        priceChartingProductInfo,
        () => {},
        undefined,
        {
          shopifySettings,
          getShopifyMappingsById,
          productShopifySettings,
          setProductShopifySettings,
        }
      );
    }
    return () => {
      isCurrent = false;
    };
    // eslint-disable-next-line
  }, [
    addInventoryItemModal,
    productDataObject?.productId,
    productDataObject?.marketPrice,
    selectedTags,
    productType,
    shopifySettings,
    productCondition,
    priceChartingProductInfo?.productMetaData?.cardRarity,
  ]);

  useEffect(() => {
    var marginDropDownObject = getMarginDropdownValue(
      handleBeautifyMarketPrice(productDataObject),
      tradeinMargin,
      productType,
      {
        ...productDataObject,
        tags: selectedTags,
        condition: productCondition?.value,
        cardRarity: productDataObject.cardRarity || EMPTY_STRING,
        subcategory: getProductSubCategory(productDataObject.genre),
      }
    );
    setMarginTypeObject(marginDropDownObject);
    // eslint-disable-next-line
  }, [productDataObject]);
  const formikKey = `${productCondition?.value}-${priceChartingProductInfo?.productMetaData?.sourceApi}`;
  return (
    <>
      <Modal
        show={addInventoryItemModal}
        size="xl"
        onHide={handleHideModal}
        animation={true}
        centered
        backdrop="static"
        className={`add-inventory-modal ${productUrl ? "iframe-opened" : ""}`}
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title className="w-100 h6">
            <div className="w-100 d-flex align-items-center gap-2">
              <span className="add-inventory-modal-header-name">
                Add Inventory
              </span>
              <Row className="w-100">
                <Col md={12} className="ps-md-0 pe-5">
                  <SearchInventory
                    customTypes={customTypes}
                    isSearchCustomProduct={true}
                    asyncSelectRef={asyncSelectRef}
                    customCategories={customCategories}
                    onSearchItemSelect={() => {
                      // New search: NONE mode (full reset), fresh interaction state
                      preserveStateRef.current.hasInteracted = false;
                      preserveStateRef.current.mode = preserveMode.NONE;
                      setSelectedTags([]);
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body d-flex ">
          <Row className={`m-0 ${productUrl ? "w-50" : "w-100"}`}>
            {/* <Col md={12} className="add-inventory-heading text-muted px-0 pb-2">
              Search from Marketplace
            </Col> */}
            {/* <Col md={12} className="mb-3 ps-md-0">
              <SearchInventory
                customTypes={customTypes}
                isSearchCustomProduct={true}
                asyncSelectRef={asyncSelectRef}
                customCategories={customCategories}
              />
            </Col> */}
            {(priceChartingProductInfo?.productMetaData?.sourceApi ===
              inventoryConstants.PRICECHARTING_API ||
              priceChartingProductInfo?.productMetaData?.sourceApi ===
                inventoryConstants.TCG_PLAYER_API) && (
              <Formik
                innerRef={formikRef}
                key={formikKey}
                initialValues={initialValues}
                enableReinitialize
                onSubmit={handleAddInvetorySubmit}
                validate={(values) =>
                  addNewIventoryValidationSchema(
                    values,
                    currentStore?.[
                      toggleSwitchButtonConstants
                        .IS_SERIAL_NUMBER_REQUIRED_INVENTORY
                    ] &&
                      isSystemProduct(
                        getProductSubCategory(productDataObject?.genre)
                      )
                  )
                }
              >
                {({ values, setFieldValue }) => {
                  return (
                    <Form>
                      <>
                        <Col
                          xs={12}
                          className="add-inventory-hero-wrapper px-0"
                        >
                          <Row className="m-0">
                            {/* Product image, meta data and Open Iframe Buttons */}
                            <ProductModalHeader
                              values={values}
                              productTags={productTags}
                              selectedTags={selectedTags}
                              setProductUrl={setProductUrl}
                              activateSpinner={activateSpinner}
                              hiddenFileInput={hiddenFileInput}
                              productDataObject={productDataObject}
                              deactivateSpinner={deactivateSpinner}
                              setProductDataObject={setProductDataObject}
                              handleReplaceButtonClick={
                                handleReplaceButtonClick
                              }
                              priceChartingProductInfo={
                                priceChartingProductInfo
                              }
                              conditionList={conditionList}
                              handleConditionChange={(selectedOption) =>
                                handleConditionChange(
                                  selectedOption,
                                  setProductCondition,
                                  priceChartingProductInfo,
                                  productTags,
                                  setProductTagsList,
                                  setProductDataObject,
                                  productDataObject,
                                  setSelectedTags,
                                  setPriceChartingProductInfo,
                                  preserveStateRef,
                                  preserveMode
                                )
                              }
                              setProductTagsList={setProductTagsList}
                              setSelectedTags={setSelectedTags}
                              setFieldValue={setFieldValue}
                              setConditionList={setConditionList}
                              productCondition={productCondition}
                              setProductCondition={setProductCondition}
                              setPriceChartingProductInfo={
                                setPriceChartingProductInfo
                              }
                            />
                            {/* Product additional check list */}
                            {productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.LOOSE ? (
                              <Col
                                md={12}
                                className="d-flex align-items-center gap-3 my-2"
                              >
                                {productDataObject.genre ===
                                TRADING_CARD_CATEGORIES_ENUMS.SYSTEM ? (
                                  productCondition?.value ===
                                  PRODUCT_CONDITIONS_ENUMS.COMPLETE ? (
                                    <>
                                      <CheckboxField
                                        name="manual"
                                        label="Manual"
                                      />
                                      {/* <CheckboxField name="box" label="Box" /> */}
                                      <CheckboxField
                                        name="cables"
                                        label="Cables"
                                      />
                                      <CheckboxField
                                        name="controller"
                                        label="Controller"
                                      />
                                    </>
                                  ) : productCondition?.value ===
                                    PRODUCT_CONDITIONS_ENUMS.LOOSE ? (
                                    <>
                                      <CheckboxField
                                        name="manual"
                                        label="Manual"
                                      />
                                      <CheckboxField
                                        name="cables"
                                        label="Cables"
                                      />
                                      <CheckboxField
                                        name="controller"
                                        label="Controller"
                                      />
                                    </>
                                  ) : (
                                    ""
                                  )
                                ) : [
                                    ...inventoryConstants.NINTENDO_CATEGORIES,
                                    ...inventoryConstants.SKYLANDER_CATEGORIES,
                                  ].includes(productDataObject.consoleName) ? (
                                  ""
                                ) : (
                                  <CheckboxField name="manual" label="Manual" />
                                )}
                              </Col>
                            ) : (
                              ""
                            )}
                            {/* Product Tags */}
                            <Col
                              md={12}
                              className="my-2 d-flex align-items-center gap-4"
                            >
                              <ProductTagList
                                className={"align-items-center"}
                                tagsList={productTagsList || []}
                                suggestedArrayList={productTags}
                                productCondition={productCondition}
                                isDisabled={isSpinnerEnabled(
                                  spinnerArray,
                                  shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
                                )}
                                onSelectTagsChange={(selectedTags) => {
                                  onSelectTagsChange(
                                    selectedTags,
                                    setSelectedTags,
                                    productDataObject,
                                    setProductDataObject,
                                    priceChartingProductInfo,
                                    productCondition,
                                    productType,
                                    preserveStateRef,
                                    preserveMode
                                  );
                                }}
                                selectedManual={{
                                  isChecked: values.manual,
                                  value:
                                    productCondition?.value ===
                                    PRODUCT_CONDITIONS_ENUMS.COMPLETE
                                      ? inventoryConstants.PRODUCT_TAGS
                                          .MISSING_MANUAL
                                      : productCondition?.value ===
                                        PRODUCT_CONDITIONS_ENUMS.LOOSE
                                      ? inventoryConstants.PRODUCT_TAGS
                                          .WITH_MANUAL
                                      : "",
                                }}
                                selectedWires={{
                                  isChecked: values.cables,
                                  value:
                                    productCondition?.value ===
                                      PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                                    productCondition?.value ===
                                      PRODUCT_CONDITIONS_ENUMS.LOOSE
                                      ? inventoryConstants.PRODUCT_TAGS
                                          .MISSING_WIRES
                                      : "",
                                }}
                                selectedController={{
                                  isChecked: values.controller,
                                  value:
                                    productCondition?.value ===
                                      PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                                    productCondition?.value ===
                                      PRODUCT_CONDITIONS_ENUMS.LOOSE
                                      ? inventoryConstants.PRODUCT_TAGS
                                          .MISSING_CONTROLLER
                                      : "",
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>

                        <Col xs={12} className="m-0 p-0 mt-4">
                          <Row className="m-0">
                            <Col md={4} className="px-0">
                              <AddEditInventoryModalPricesHistoryStats
                                productDataObject={productDataObject}
                                setProductDataObject={setProductDataObject}
                                propertyNameOfStatCardsToHide={[
                                  "totalUnitsSold",
                                ]}
                                isShowInStoreOnlineQuantityCheck={true}
                                handleStoreAndOnlineQuantityChange={
                                  handleStoreAndOnlineQuantityChange
                                }
                                handleCustomShopifyStatusChange={
                                  handleCustomShopifyStatusChange
                                }
                              />
                            </Col>
                            <Col md={8} className="pe-0">
                              <Row className="m-0">
                                <AddInventoryProductPrices
                                  values={values}
                                  productTags={productTags}
                                  productType={productType}
                                  selectedTags={selectedTags}
                                  currentStore={currentStore}
                                  setFieldValue={setFieldValue}
                                  markupPresets={markupPresets}
                                  marginTypeObject={marginTypeObject}
                                  productDataObject={productDataObject}
                                  priceChartingProductInfo={
                                    priceChartingProductInfo
                                  }
                                  productUrl={productUrl}
                                />
                                <Col
                                  md={12}
                                  className="d-flex align-items-end gap-2 pe-0"
                                >
                                  <Button
                                    label={buttonNameConstants.CANCEL}
                                    className="w-100"
                                    type="button"
                                    handleClick={() => handleHideModal()}
                                    buttonType={
                                      buttonTypeConstants.GHOST_BUTTON
                                    }
                                    isDisabled={isAddInventoryInProgress(
                                      spinnerArray
                                    )}
                                  />
                                  <Button
                                    label={buttonNameConstants.ADD_TO_INVENTORY}
                                    className="w-100"
                                    type="submit"
                                    isDisabled={isAddInventoryInProgress(
                                      spinnerArray
                                    )}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </>
                    </Form>
                  );
                }}
              </Formik>
            )}
            {(!priceChartingProductInfo ||
              priceChartingProductInfo?.productMetaData?.sourceApi ===
                inventoryConstants.CUSTOM_ITEM) && (
              <>
                {/* <Col md={12} className="px-0 d-flex justify-content-center">
                  <hr className="w-75" />
                </Col> */}
                <Formik
                  innerRef={formikRef}
                  initialValues={customItemInitialValues}
                  validate={addCustomItemValidationSchema}
                  onSubmit={handleCustomItemSubmit}
                >
                  {({ values, setFieldValue }) => {
                    if (
                      priceChartingProductInfo?.productMetaData?.sourceApi ===
                      inventoryConstants.CUSTOM_ITEM
                    ) {
                      setIsProductExist(
                        getCustomProductIfExist(
                          values,
                          customTypes,
                          customCategories,
                          {
                            productsAvailableInInventory: [
                              priceChartingProductInfo?.productObject,
                            ],
                          },
                          customSubCategories,
                          customProductSelectedTags
                        )
                      );
                    }

                    return (
                      <Form className="px-0">
                        <Col md={12} className="px-0">
                          <CustomInventoryComponent
                            values={values}
                            formikRef={formikRef}
                            productTags={productTags}
                            setFieldValue={setFieldValue}
                            isProductExist={isProductExist}
                            handleHideModal={handleHideModal}
                            isCustomItemTab={isCustomItemTab}
                            setIsCustomItemTab={setIsCustomItemTab}
                            customProductSelectedTags={
                              customProductSelectedTags
                            }
                            onCustomProductSelectTagsChange={
                              onCustomProductSelectTagsChange
                            }
                            handleShopifyStatusChange={
                              handleCustomShopifyStatusChange
                            }
                            isEditCustomItemModal={true}
                          />
                        </Col>
                      </Form>
                    );
                  }}
                </Formik>
              </>
            )}
          </Row>
          {productUrl && (
            <Row className="m-0 w-50">
              <Col md={12}>
                {productUrl && (
                  <iframe
                    title="Product Iframe"
                    src={productUrl}
                    className="iframe-website"
                  />
                )}
              </Col>
            </Row>
          )}
        </Modal.Body>

        {productUrl && (
          <button
            type="button"
            onClick={() => {
              setProductUrl("");
            }}
            className="iframe-toogle-button"
          >
            <SidebarToggleIcon className={"iframe-toggle-icon"} />
          </button>
        )}
      </Modal>
      <ConsolidationModal />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  inventory: state.inventory,
  tradeDiscount: state.tradeDiscount,
  productTags: state.inventory.productTags,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  isAddModalOpen: state.inventory.isAddModalOpen,
  inventoryProducts: state.inventory.inventoryProducts,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
  isConsolidationModal: state.inventory.consolidationModal.isConsolidationModal,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addInventory: (data, handleHideModal) =>
    dispatch(inventoryActions.addInventory(data, handleHideModal)),
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  toggleAddModal: (value) => dispatch(inventoryActions.toggleAddModal(value)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getInventoryByPricechartingId: (storeId, data) =>
    dispatch(inventoryActions.getInventoryByPricechartingId(storeId, data)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
  getShopifyMappingsById: (storeId, id) =>
    dispatch(shopifyActions.getShopifyMappingsById(storeId, id)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AddInventoryItem);
